import {
  IPoolsPermissions,
  IUsersPermissions,
  TApiaDocumentDefinition,
  TDocumentMetadata,
  TUploaderFileInfo,
} from '../../../../common/uploader/types';
import UploaderApi from '../../../../common/uploader/UploaderApi';
import ModalRenderer from './ModalRenderer';
import makeRemoteOpenedModal from '../makeRemoteOpenedModal';

export type TUploadModalStore = {
  additionalMetadata: Record<string, { name: string; value: string }>;
  allDocTypes: boolean;
  allowChangeDocType: boolean;
  cmbDocType: string;
  docAllowAllType: string;
  docDesc: string;
  docExpDate: string;
  docFolder: string;
  fromDirectoryFile: TApiaDocumentDefinition | null;
  isFreeMetadata: boolean;
  isReadonly: boolean;
  isReadonlyDoctype: boolean;
  metadata: Record<string, TDocumentMetadata>;
  metadatas: TDocumentMetadata[];
  poolsPermissions: IPoolsPermissions[];
  shownFiles: File[];
  userChangedDocType: boolean;
  usersPermissions: IUsersPermissions[];
  versioningFile: TUploaderFileInfo | null;
};

type TOpenUploadDocumentModal = {
  api: UploaderApi;
  initialValues?: Partial<TUploadModalStore>;
  langId?: number;
  newFiles?: File[];
  translatingFile?: TUploaderFileInfo;
};

export type TUploadDocumentModalData = TOpenUploadDocumentModal;
export const documentUploadModalId = 'documentUploadModal';

const { Modal: DocumentUploadModal } =
  makeRemoteOpenedModal<TUploadDocumentModalData>({
    noHeader: true,
    Child: ModalRenderer,
    id: documentUploadModalId,
    className: documentUploadModalId,
    size: 'flex',
    shouldCloseOnOverlayClick: false,
  });

export default DocumentUploadModal;
